import { NgModule } from '@angular/core';
import { TemplateDirective } from './template.directive';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RenderDirective } from './render.directive';

@NgModule({
  declarations: [TemplateDirective, RenderDirective],
  imports: [CommonModule, FormsModule],
  exports: [TemplateDirective, RenderDirective],
})
export class DirectivesModule {}
